import styles from '../../assets/css/error.module.css';
import SupportIcon from '../svgs/SupportIcon';
import TextCustomization from '../customizations/TextCustomization';
import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';

const REFERENCE_NUMBER_PLACEHOLDER = 'ReferenceNumber';

interface Props {
	referenceNumber?: string;
}

const SupportSection: FC<Props> = ({ referenceNumber }) => {
	const { t } = useTranslation();

	const refNumber = referenceNumber || v4();
	const header = t('auth-rejected-step.contact-support');
	const content = t('auth-rejected-step.support-content-markdown', {
		[REFERENCE_NUMBER_PLACEHOLDER]: refNumber
	});

	return (
		<Box className={styles['session-error-page']}>
			<span className={styles['step-header-text']}>{header}</span>
			<div className={styles['support-container']} style={{ paddingBottom: '0' }}>
				<div className={styles['support-icon-container']}>
					<SupportIcon />
				</div>
				<div className={styles['support-content']}>
					<div className={styles['support-text']} style={{ textAlign: 'left', paddingLeft: '10px' }}>
						<TextCustomization content={content} />
					</div>
				</div>
			</div>
		</Box>
	);
};

export default SupportSection;
